(() => {
  'use strict';
  const analyticsId = 'G-N20Q5VW2GF';
  const containerId = 'GTM-W8FWNMDX';
  let analyticsLoaded = false;
  let containerLoaded = false;
  let trustpilotLoaded = false;
  let previous = null;
  let reloading = false;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag('consent', 'default', {
    analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied'
  });
  window['ga-disable-' + analyticsId] = true;
  function loadScript(id, src) {
    if (document.getElementById(id)) return;
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    document.head.appendChild(script);
  }
  function applyConsent() {
    const api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.currentVisitorConsent !== 'function') return;
    const consent = api.currentVisitorConsent();
    const analytics = consent.analytics === 'yes' && api.analyticsProcessingAllowed();
    const marketing = consent.marketing === 'yes' && api.marketingAllowed();
    const preferences = consent.preferences === 'yes' && api.preferencesProcessingAllowed();
    window['ga-disable-' + analyticsId] = !analytics;
    window.gtag('consent', 'update', {
      analytics_storage: analytics ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing ? 'granted' : 'denied'
    });
    if (previous && ((previous.analytics && !analytics && analyticsLoaded) ||
      (previous.marketing && !marketing && containerLoaded))) {
      if (!reloading) { reloading = true; window.location.reload(); }
      return;
    }
    previous = { analytics, marketing, preferences };
    if (analytics && !analyticsLoaded) {
      analyticsLoaded = true;
      window.gtag('js', new Date());
      window.gtag('config', analyticsId, { allow_google_signals: marketing, allow_ad_personalization_signals: marketing });
      loadScript('mxpro-consented-analytics', 'https://www.googletagmanager.com/gtag/js?id=' + analyticsId);
    }
    if (analytics && marketing && !containerLoaded) {
      containerLoaded = true;
      window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
      loadScript('mxpro-consented-gtm', 'https://www.googletagmanager.com/gtm.js?id=' + containerId);
    }
  }
  document.addEventListener('visitorConsentCollected', applyConsent);
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-mxpro-cookie-preferences]');
    if (!button) return;
    const error = button.parentElement.querySelector('[data-mxpro-cookie-error]');
    button.disabled = true;
    if (error) error.hidden = true;
    try {
      if (!window.privacyBanner) {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }
      await window.privacyBanner.showPreferences();
    } catch (failure) {
      if (error) error.hidden = false;
    } finally { button.disabled = false; }
  });
  function initialize() {
    // Official display widgets do not require cookies; analytics and advertising stay consent-gated.
    if (!trustpilotLoaded) {
      trustpilotLoaded = true;
      loadScript('mxpro-trustpilot-display', 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js');
    }
    if (window.Shopify && window.Shopify.customerPrivacy) {
      applyConsent();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) applyConsent();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();

